import axios from "axios"
import baseURL from "../configs/api"

export const post_CreditCard = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}creditCard?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const getCreditCards = (tenantId: string) => {
    return getFetch("creditCard", tenantId)
}

export const getCreditCard = (primaryKey: string, tenantId: string) => {
    return getFetch(`creditCard/${primaryKey}`, tenantId)
}

export const getCreditCardOfCustomer = (customerId: number, tenantId: string) => {
    return getFetch(`creditCard`, tenantId, { customerId })
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}